/*
 * @Author: bbqin
 * @Date: 2022-09-09 15:33:39
 * @LastEditTime: 2022-09-19 14:58:57
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\FastExtend\plugins\register.js
 * (混沌)足够多的方案才能接近真实的结果。
 */

import React, { Component } from "react";
import * as log from '../utils/log';

export default function (CustomComponent) {

    class Wrapper extends Component {
        constructor(props) {
            super(props);
            let page = props.page;
            let id = props.id;
            if (!id) {
                log.error(id, '没有id可能会对组件有影响');
            }
            if (!page) {
                log.error(page, '没有page可能会对组件有影响');
            }
            this.state = {
                ...props,
                id: id,
                page: page,
            };

            // 记录当前组件对象
            (page?.fastExtend || {})[id] = this;
        }

        UNSAFE_componentWillReceiveProps(nextProps) {
            let shouldUpdate = false;
            let newProps = {};
            for (const key in nextProps) {
                if (this.state[key] === undefined && nextProps[key] !== undefined && this.state[key] !== nextProps[key]) {
                    shouldUpdate = true;
                    newProps[key] = nextProps[key];
                }
            }
            shouldUpdate && this.setState({ ...newProps });
        }

        componentWillUnmount() {
            let { page, id } = this.state;
            // 销毁挂载的对象
            delete (page?.fastExtend || {})[id];
        }

        //设置属性
        setAttribute = (attribute, value) => {
            this.setState({ [attribute]: value });
        }

        // 获取属性
        getAttribute = attribute => {
            return this.state[attribute];
        }

        render() {
            let { children } = this.props;
            let { children: unUse, ...others } = this.state;
            return <CustomComponent {...others} >{children}</CustomComponent>;
        }
    }

    return Wrapper;
}